module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "fxt-template-layout10"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-12 fxt-bg-img",
    attrs: {
      "md6": "",
      "data-bg-image": "../../../static/img/bg14-l.jpg"
    }
  }, [_c('div', {
    staticClass: "fxt-header"
  }, [_c('div', [_c('h1', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.analyst')) + " ")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.paidTitle')))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "col-12 fxt-bg-color",
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "fxt-content"
  }, [_c('div', {
    staticClass: "fxt-form fxt-footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLink),
      expression: "isShowLink"
    }]
  }, [_c('h2', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("activation.hint")))]), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "flat": "",
      "medium": "",
      "color": "primary"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.$t("activation.link")))])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMessage),
      expression: "isShowMessage"
    }]
  }, [_c('div', {
    staticClass: "mb-3 font-14"
  }, [_vm._v(_vm._s(_vm.$t("activation.valid")))]), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "medium": "",
      "color": "primary"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v(_vm._s(_vm.$t("allPage.homepage")))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "fxt-footer"
  }, [_c('ul', {
    staticClass: "fxt-socials"
  }, [_c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBots_",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBotsPro",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-linkedin fxt-transformY-50 fxt-transition-delay-9"
  }, [_c('a', {
    attrs: {
      "href": "https://t.me/iob_llc",
      "title": "Telegram"
    }
  }, [_c('i', {
    staticClass: "fab fa-telegram-plane"
  })])])])])])])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37122e08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/Activation.vue
// module id = 430
// module chunks = 0